import React from "react";
import { Avatar } from "antd";
import { USABLE_ICONS, CORE_VALUE_META, getIcon } from "variables/constants";

const PreviousWinnersCard = ({
  recordList
}) => {
  return (
    <div>
      {recordList?.map((item, index) => {
        const coreValueMeta = CORE_VALUE_META[item?.core_value_name] ?? {};
        
        const IconComponent =
          coreValueMeta.icon && USABLE_ICONS[coreValueMeta.icon]
            ? USABLE_ICONS[coreValueMeta.icon]
            : null;
      
        const colorClass = coreValueMeta.color ?? "blue";

        return (
          <div key={index} className={`flex rounded-xl winners w-full transition-all my-2 border p-4`}>
            <div className="flex items-center justify-between gap-4 w-full">
              <div className="flex items-center gap-3 flex-1">
                <Avatar
                  size={48}
                  className={`!rounded-full icon-style ${colorClass} flex items-center justify-center shadow-md`}
                >
                  {item?.employee_initials}
                </Avatar>

                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-semibold text-[14px] title-text">
                      {item?.employee_name}
                    </h4>

                    <span
                      className={`status-indicator !py-0.5  text-[9px] ${colorClass} `}
                    >
                      {item?.core_value_name}
                    </span>
                  </div>

                  <p className="text-[12px] muted-text">
                    {item?.employee_position}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="text-right">
                  <div className="flex items-center gap-1 mb-1">
                    <span>{getIcon(item?.country_code, "w-3 h-2 rounded-sm")}</span>
                    <span className="text-[11px] muted-text">
                      {item?.employee_country_name}
                    </span>
                  </div>

                  <p className="text-[12px] muted-text tracking-wide">
                    {item?.award_month_label}
                  </p>
                </div>

                <div
                  className={`w-8 h-8 icon-style ${colorClass} flex items-center justify-center`}
                >
                  {IconComponent &&
                    React.createElement(IconComponent, {
                      className: "w-4 h-4 text-white",
                    })}
                </div>
              </div>

            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PreviousWinnersCard;